export default {
  logGeneral: false,
  logNetworkErrors: false,
};
